import log from '/js/common/Logger';
import Dfp from './dfp/dfp';
import dfp_config from './dfp/dfp_config';
import Utils from '/js/common/Utils';
import _ from 'lodash';
import {generateAllBidders} from './hb/hb_bidders_config';
import config from './dfp/dfp_config';

class Ads {

  constructor(isLazy, dfpModule) {
    this.dfp = dfpModule;
    this.currPlacementIdx = 1;
    this.isLazy = isLazy;
    if (this.isLazy) {
      let options = {
        root: null, // relative to document viewport
        rootMargin: '0px 0px 50% 0px', // margin around root. Values are similar to css property. Unitless values not allowed
        threshold: 1.0, // visible amount of item shown in relation to root
      };
      this.observer = new IntersectionObserver(this.onLazyLoad.bind(this), options);
    }
  }

  onLazyLoad(entries, observer) {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        let placementEl = entry.target;
        observer.unobserve(placementEl);
        log.debug('lazy loaded placement ' + placementEl.dataset.pmdPlacementIdx);
        this.dfp.fillPlacementsWithAds();
        this.dfp.displaySingleAd(placementEl);
      }
    });
  }

  init() {
    if (this.isInit) return;
    this.lastHooksCount = -9999;
    this.isInit = true;
    log.debug(`Ads::init`);
  }

  createPlacementEl(placementName, extraStyle = {}, extraData = {}) {
    let el = document.createElement('div');
    el.classList.add('pomad-placement');
    el.dataset.pmdPlacementIdx = this.currPlacementIdx;
    el.dataset.pmdPlacementName = placementName;
    Object.assign(el.dataset, extraData);
    Object.assign(el.style, extraStyle);
    el.style.textAlign = 'center';
    el.id = 'pmd-placement-' + placementName + '-' + this.currPlacementIdx;
    this.currPlacementIdx++;
    return el;
  }

  createPlacementBefore(placementName, hookEl, extraStyle = {}, extraData = {}) {
    let plEl = this.createPlacementEl(placementName, extraStyle, extraData);
    hookEl.parentNode.insertBefore(plEl, hookEl);
  }

  _createPlacementsForPage(sizeLimitFunc) {
    if (location.pathname==='/viewpdf.html') {

      const screen_width = Utils.getWindowWidth();
      const bodyEl = document.body;
      const containerEl = document.getElementById('container');
      if (screen_width >= 1600 && containerEl) {
        containerEl.style['margin'] = '0';
        bodyEl.style['display'] = 'flex';
        bodyEl.style['justify-content'] = 'center'

        const leftWrapEl = document.createElement('div');
        leftWrapEl.classList.add('left-side-wrapper');

        const rightWrapEl = document.createElement('div');
        rightWrapEl.classList.add('right-side-wrapper');

        bodyEl.insertBefore(leftWrapEl, containerEl);
        bodyEl.appendChild(rightWrapEl);

        let placementEl = this.createPlacementEl('left-aside', {
          width: screen_width > 1880 ? '300px' : '160px',
          'max-width': '300px',
          height: '600px',
          position: Utils.isSafari() ? '-webkit-sticky' : 'sticky',
          display: 'inline-block',
          top: '120px',
          left: 0,
        });
        leftWrapEl.appendChild(placementEl);

        placementEl = this.createPlacementEl('right-aside', {
          width: screen_width > 1880 ? '300px' : '160px',
          'max-width': '300px',
          height: '600px',
          // background: 'red',
          position: Utils.isSafari() ? '-webkit-sticky' : 'sticky',
          display: 'inline-block',
          top: '120px',
          left: 0,
        });
        rightWrapEl.appendChild(placementEl);

        const sizeLimitationFunction = (sizes) => {
          sizes = _.filter(sizes, size => !_.isArray(size) || size[0] == 1 ? size : size[0] <= (screen_width > 1880 ? 300 : 160));
          if (sizes.length == 1 && sizes[0] == 1) return [];
          return sizes;
        }
        sizeLimitFunc['left-aside'] = sizeLimitationFunction;
        sizeLimitFunc['right-aside'] = sizeLimitationFunction;
      }
    }
  }

  fill() {
    this.dfp.fillPlacementsWithAds();
    // if (DEBUG) {
    //   createDebugOverlays();
    // }
  }

  refresh(element_id, override, keyVals) {
    this.dfp.refreshById(element_id, override, keyVals);
  }

  refreshByAdUnitName(adUnitName, override, keyVals) {
    this.dfp.refreshByAdUnitName(adUnitName, override, keyVals);
  }


  _getDfpPageConfig() {
    const isMobile = Utils.isMobileByWidth();
    let config = dfp_config;
    let all = _.head(config.pages.filter(page => {
      return page.name === '__ALL__';
    }));
    let res = _.head(config.pages.filter(page => {
      if (page.urlRegex) {
        let found = false;
        page.url.forEach(url => {
          if (found) return found;
          let exp = new RegExp(url);
          found = exp.test(location.pathname);
        });
        return found;
      } else {
        return page.url.indexOf(location.pathname) > -1;
      }

    }));
    if (_.isNil(res)) res = all;
    if (isMobile) {
      res.placements = res.mobile.placements;
      res.ad_unit_defaults = res.mobile.ad_unit_defaults;
    } else {
      res.placements = res.desktop.placements;
      res.ad_unit_defaults = res.desktop.ad_unit_defaults;
    }
    if (all) {
      if (isMobile) {
        all.placements = all.mobile.placements;
        all.ad_unit_defaults = all.mobile.ad_unit_defaults;
      } else {
        all.placements = all.desktop.placements;
        all.ad_unit_defaults = all.desktop.ad_unit_defaults;
      }
      if (res.ad_unit_defaults === undefined) res.ad_unit_defaults = all.ad_unit_defaults;
      if (res.placements === undefined) {
        res.placements = all.placements;
      } else {
        Object.keys(all.placements).forEach(key => {
          if (res.placements[key]) return;
          res.placements[key] = all.placements[key];
        });
      }
      ;
    }
    log.info('page:', res);
    return res;
  }

  getFloor(adUnitElemId) {
    return _.result(this.dfp, `idsToAdUnits[${adUnitElemId}].floor`, _.result(dfp_config, 'options.default_floor', 0.03));
  }

  /**
   *
   * @param sizeLimitFunc (String placementName, Array size) -> Array sizes -
   * a function that gets the placement name and the available sizes and can manipulate the available sizes
   * @returns {Promise<void>}
   */
  async bind(sizeLimitFunc) {
    this.pageConfig = this._getDfpPageConfig();
    const screen_width = Utils.getWindowWidth();
    this._createPlacementsForPage(sizeLimitFunc);
    _.forEach(this.pageConfig.placements, (placement, placementName) => {
      _.forEach(placement.ad_units, adUnit => {
        let sizes = adUnit.sizes;
        if (_.isEmpty(sizes)) sizes = this.pageConfig.ad_unit_defaults.sizes;
        sizes = _.filter(sizes, size => (!_.isArray(size) || size[0] == 1 || size[0] <= screen_width));
        if (sizeLimitFunc && _.isFunction(sizeLimitFunc)) {
          sizes = sizeLimitFunc(placementName, sizes)
        }
        adUnit.sizes = sizes;
        //console.log(`${adUnit.name} - ${sizes}`)
        if (config.is_hb) {
          adUnit.bidders = generateAllBidders(adUnit, sizes);
        }
      })
    });

    if (this.pageConfig === null) {
      log.warning('no ad page config found for this page');
      return;
    }
    this.dfp.setPlacements(this.pageConfig.placements);
    await this.dfp.init();
    //setTimeout(() => {
    this.dfp.fillPlacementsWithAds();
    if (this.isLazy) {
      const existingPlacementsEl = document.querySelectorAll('.pomad-placement');
      _.forEach(existingPlacementsEl, currEl => {
        this.observer.observe(currEl);
      });
    }
    // if (DEBUG) {
    //   createDebugOverlays();
    // }
    //}, 0);
  }
}

const dfp = new Dfp(dfp_config.id, false, config.is_hb);
const instance = new Ads(false, dfp);//isIntersectionObserverSupported);
window.rt = window.rt || {};
window.rt.client = window.rt.client || {};
window.rt.client.fill = instance.fill.bind(instance);
window.rt.client.refresh = instance.refresh.bind(instance);
window.rt.client.refreshByName = instance.refreshByAdUnitName.bind(instance);
window.rt.client.getFloor = instance.getFloor.bind(instance)
export default instance;
